import React, {useCallback, useMemo} from 'react';
import {Calendar} from '../calendar';
import {Popup} from '../popup';
import {DatePickerTrigger} from './DatePickerTrigger';
import {DatePickerProps} from './types';

export const DatePicker: React.FC<DatePickerProps> = ({
  onDateChanged,
  kind = 'Default',
  size = 'Default',
  title,
  flex,
  unselectedTitle = 'Pick date',
  selectedDate,
}) => {
  // Callback
  const handleDateChanged = useCallback(
    (date: Date) => {
      onDateChanged && onDateChanged(date);
    },
    [onDateChanged],
  );

  // Calculate current date with fallback for invalid dates
  const currentDate = useMemo(() => {
    if (selectedDate && isNaN(selectedDate.getTime())) {
      return undefined;
    }
    return selectedDate;
  }, [selectedDate]);

  // Calculate button title
  const buttonTitle = useMemo(() => {
    return currentDate
      ? currentDate.toLocaleString('default', {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        })
      : unselectedTitle;
  }, [currentDate, unselectedTitle]);

  return (
    <Popup
      flex={flex}
      trigger={
        <DatePickerTrigger
          caption={title}
          title={buttonTitle}
          size={size}
          kind={kind}
        />
      }>
      {closeMenu => (
        <Calendar
          currentDate={currentDate || new Date()}
          onChange={date => {
            handleDateChanged(date);
            closeMenu();
          }}
        />
      )}
    </Popup>
  );
};
